export var NotificationType = {
  Email: 'Email',
  Candidate: 'Candidate',
  Texts: 'Texts',
  Authorisations: 'Authorisations',
  OnBoardingNotification: 'OnBoardingNotification',
  MyTasks: 'MyTasks',
  MyTasksPending: 'MyTasksPending',
  IsTabAccess: 'yes'
}
export const Tasks = {
  JobsPendingApproval: 'JobsPendingApprovalTask',
  ReviewApplications: 'ReviewApplicationsTask',
  ReviewAttractionStrategy: 'ReviewAttractionStrategyTask',
  ArrangeInterviews: 'ArrangeInterviewsTask',
  RecordInterviewOutcomes: 'RecordInterviewOutcomesTask',
  UpcomingInterviews: 'UpcomingInterviewsTask',
  Offers: 'OffersTask',
  ReviewReferences: 'ReviewReferencesTask',
  ChaseReference: 'ChaseReferenceTask',
  RequestFurtherReferences: 'RequestFurtherReferencesTask',
  ChaseCompliance: 'ChaseComplianceTask',
  ChaseOnboarding: 'ChaseOnboardingTask',
  PrepareForNewStarter: 'PrepareForNewStarterTask',
  ChaseGapConcern: 'ChaseGapConcernTask',
  ReviewOnboarding: 'ReviewOnboardingTask',
  ReviewCompliance: 'ReviewComplianceTask'
}

export const TaskCategory = {
  JobsPendingApproval: 'Job Approval',
  Applications: 'Applications',
  Interviews: 'Interview',
  References: 'References',
  Onboarding: 'Onboarding',
  Compliance: 'Compliance',
  Offers: 'Offers',
}
export const TaskIcons = {
  JobsPendingApproval: 'clip_board',
  ReviewApplications: 'new_applications_candidates',
  ReviewAttractionStrategy: 'promote',
  ArrangeInterviews: 'clock_icon',
  RecordInterviewOutcomes: 'clip_board_red',
  UpcomingInterviews: 'calendar-accepted',
  Offers: 'clip_board_puple',
  ReviewReferences: 'clip_board_puple',
  ChaseReference: 'offer_attention',
  RequestFurtherReferences: 'clip_board_puple',
  ChaseCompliance: 'offer_attention',
  ChaseOnboarding: 'offer_attention',
  PrepareForNewStarter: 'New_starters',
  ChaseGapConcern: 'offer_attention',
  ReviewOnboarding: 'clip_board_puple',
  ReviewCompliance: 'clip_board_puple'
}
